import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Link as ScrollLink } from 'react-scroll';

const Hero: React.FC = () => {
  return (
    <section 
      id="hero" 
      className="relative h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay oscuro para mejorar legibilidad */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      
      {/* Contenido del Hero */}
      <div className="container relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto"
        >
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6">
            Descubre Propiedades Exclusivas para un Estilo de Vida Excepcional
          </h1>
          <p className="text-xl text-gray-100 mb-8">
            Casas y apartamentos de lujo seleccionados para quienes buscan lo extraordinario
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button className="btn btn-secondary">Descubre tu nuevo hogar</button>
            <button className="btn btn-outline text-white border-white hover:bg-white hover:text-dark">
              Conoce más
            </button>
          </div>
        </motion.div>
      </div>
      
      {/* Flecha de scroll */}
      <ScrollLink
        to="properties"
        spy={true}
        smooth={true}
        offset={-100}
        duration={500}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 cursor-pointer"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 1.5 }}
          className="text-white"
        >
          <ChevronDown size={32} />
        </motion.div>
      </ScrollLink>
    </section>
  );
};

export default Hero;